import React, { FC, ReactNode } from 'react'
import { FormLoginBody } from './styled'
import Typography from '@mui/material/Typography'

interface ILoginFormBody {
	children?: ReactNode
	title?: string | number
	subTitle?: string | number
	sx?: object
}

const LoginFormBody: FC<ILoginFormBody> = ({
	children,
	title,
	subTitle,
	sx,
}: ILoginFormBody) => {
	return (
		<FormLoginBody sx={sx}>
			<Typography
				component={'h1'}
				align={'center'}
				variant={'h4'}
				sx={{ mb: 0.8 }}
			>
				{title}
			</Typography>

			<Typography align={'center'} paragraph sx={{ fontSize: '1.125rem' }}>
				{subTitle}
			</Typography>

			{children}
		</FormLoginBody>
	)
}

export default LoginFormBody
